/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAIUnitEconomicsCost extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAIUnitEconomicsCost");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAIUnitEconomicsCost.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAIUnitEconomicsCost>): BackgroundJobPayloadForAIUnitEconomicsCost {
        let obj = Object.assign(new BackgroundJobPayloadForAIUnitEconomicsCost(), model);
        BackgroundJobPayloadForAIUnitEconomicsCost.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAIUnitEconomicsCost>): BackgroundJobPayloadForAIUnitEconomicsCost {
        if (!model) return null;
        return BackgroundJobPayloadForAIUnitEconomicsCost.newInstance(<BackgroundJobPayloadForAIUnitEconomicsCost> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAIUnitEconomicsCost) {
        if (!obj) return;

        models.BackgroundJobPayloadForAIUnitEconomicsCost.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAIUnitEconomicsCost): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAIUnitEconomicsCost.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Baseline whose configuration keys are consolidated into cost buckets
     */
    baseline_id: string;

}
